import { GridSingleSelectColDef } from '@mui/x-data-grid-pro';
import { standardOperators, datePickerOperator } from '../../../Compounds/UpstackDataGrid/helpers';
import { getDate, getFormattedDate } from '../../../../utils/helpers';

export const DefaultCommissionGridColumnDefs: GridSingleSelectColDef[] = [
  {
    field: 'createdAt',
    headerName: 'Date',
    sortable: true,
    valueFormatter: (value) => {
      return getFormattedDate(value, 'lll');
    },
    valueGetter: (value) => {
      return value ? getDate(value).getTime() : '';
    },
    filterable: true,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    filterOperators: [datePickerOperator]
  },
  {
    field: 'email',
    headerName: 'Requestor',
    sortable: true,
    filterable: true,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    filterOperators: standardOperators()
  },
  {
    field: 'status',
    headerName: 'Status',
    sortable: true,
    filterable: true,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    filterOperators: standardOperators()
  }
];
